<pa-checkbox-tree ngDefaultControl
                  [formControl]="control"
                  type="radio"
                  [checkboxes]="checkboxes"
                  (selection)="onSelection($event)">{{ schema.title }}</pa-checkbox-tree>